export const filter = {
    id: "",
    name: "",
    amount: "",
    description: "",
    search: "",
    created_at: "",
    updated_at: "",
};
